import { render, staticRenderFns } from "./multichart.vue?vue&type=template&id=2b350e3f&scoped=true&"
import script from "./multichart.vue?vue&type=script&lang=js&"
export * from "./multichart.vue?vue&type=script&lang=js&"
import style0 from "./multichart.vue?vue&type=style&index=0&id=2b350e3f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b350e3f",
  null
  
)

export default component.exports